import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";

export const WhatWeOfferWrapper = styled.div`
    text-align: center;
    margin-top: 5rem;
`

export const CardsWrapper = styled.div`
    margin-top: 4rem;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-row-gap: 2rem;
    grid-column-gap: 2rem;

    @media only screen and (max-width: ${globalStyles.breakpoints.large}) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.medium}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        grid-template-columns: minmax(0, 1fr);
    }
`
    
export const Card = styled.div`
    border: 1px solid #dbeafe;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
        transform: scale(1.1);
    }
`

export const IconWrapper = styled.div`
    padding: 1rem;
    height: 4rem;
    width: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #dbeafe;
    border-radius: 50%;
`

export const Icon = styled.img`
    height: 2rem;
    width: auto;
`